module.exports = [{
      plugin: require('/tmp/7fb7bf9/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"remarkPlugins":[null,null,null]},
    },{
      plugin: require('/tmp/7fb7bf9/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
